import React, { useState } from 'react';
import { useIsMobile } from '@repo/common';
import ConfirmPasswordForm from '../../../components/MyPage/AccountSetting/DeleteAccount/ConfirmPasswordForm';
import FinalDeleteConfirm from '../../../components/MyPage/AccountSetting/DeleteAccount/FinalDeleteConfirm';
import FinalDeleteSuccess from '../../../components/MyPage/AccountSetting/DeleteAccount/FinalDeleteSuccess';

const DeleteAccount = () => {
  const isMobile = useIsMobile();
  const [step, setStep] = useState('confirm');
  return (
    <div className='flex items-center justify-center bg-grayscale-gray00 w-full min-h-screen tabletH:min-h-[973px] px-4 pt-6 pb-[180px] tabletH:p-10 tabletH:pb-[120px]'>
      {step === 'confirm' && (
        <ConfirmPasswordForm onSuccess={() => setStep('final')} />
      )}
      {step === 'final' && (
        <FinalDeleteConfirm
          onSuccess={() => setStep('success')}
          $isMobile={isMobile}
        />
      )}
      {step === 'success' && <FinalDeleteSuccess $isMobile={isMobile} />}
    </div>
  );
};

export default DeleteAccount;
